import { useMutation, useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import {
  InventoryStockPolicyRowType,
  ProductionCapacityRowType,
} from './SystemOfRecords.types'
import { toast } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

const fetchInventoryStockPolicy = async () => {
  const { data } = await request({
    url: '/system-of-records/inventory-stock-policy',
    method: 'GET',
  })
  return data
}
export const useGetInventoryStockPolicy = () => {
  return useQuery('inventory-stock-policy', () => fetchInventoryStockPolicy(), {
    enabled: true,
    select: ({ data }) => {
      return data?.data
    },
    refetchOnWindowFocus: false,
  })
}

const fetchProductionCapacity = async () => {
  const { data } = await request({
    url: '/system-of-records/production-capacity',
    method: 'GET',
  })
  return data
}
export const useGetProductionCapacity = () => {
  return useQuery(['production-capacity'], () => fetchProductionCapacity(), {
    enabled: true,
    select: ({ data }) => data?.data,
    refetchOnWindowFocus: false,
  })
}

const updateInventoryStockPolicy = async (
  editedRows: Record<number, InventoryStockPolicyRowType>
) => {
  const { data } = await request({
    url: '/system-of-records/inventory-stock-policy',
    method: 'PUT',
    data: editedRows,
  })
  return data
}

export const useUpdateInventoryStockPolicy = (
  onUpdateSuccess: () => void,
  onUpdateFailure: () => void
) => {
  return useMutation(updateInventoryStockPolicy, {
    onSuccess: () => {
      onUpdateSuccess()
    },
    onError: () => {
      onUpdateFailure()
    },
  })
}

const updateProductionCapacity = async (
  editedRows: Record<number, ProductionCapacityRowType>
) => {
  await request({
    url: '/system-of-records/production-capacity',
    method: 'PUT',
    data: editedRows,
  })
}

export const useUpdateProductionCapacity = (
  onUpdateSuccess: () => void,
  onUpdateFailure: () => void
) => {
  return useMutation(updateProductionCapacity, {
    onSuccess: () => {
      onUpdateSuccess()
    },
    onError: () => {
      onUpdateFailure()
    },
  })
}

const updateMasterData = async () => {
  await request({
    url: '/system-of-records/update-master-data',
    method: 'PUT',
  })
}

export const useUpdateMasterData = () => {
  const navigate = useNavigate()
  return useMutation(updateMasterData, {
    onSuccess: () => {
      navigate('/')
      toast.success('Successfully initialized master data update')
    },
    onError: () => {
      toast.error('Failed to initialize master data update')
    },
  })
}

const fetchSORStatus = async () => {
  const { data } = await request({
    url: '/system-of-records/status',
    method: 'GET',
  })
  return data
}

export const useGetSORStatus = () => {
  return useQuery(['system-of-records-status'], () => fetchSORStatus(), {
    select: ({ data }) => data,
    refetchInterval: 10000,
    cacheTime: 0,
  })
}

/*** Upload */

const uploadInventoryStockPolicy = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await request({
    url: '/system-of-records/inventory-stock-policy',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

export const useUploadInventoryStockPolicy = (
  onUploadSuccess: () => void,
  onUploadFailure: () => void
) => {
  return useMutation(uploadInventoryStockPolicy, {
    onSuccess: () => {
      onUploadSuccess()
    },
    onError: () => {
      onUploadFailure()
    },
  })
}

const uploadProductionCapacity = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await request({
    url: '/system-of-records/production-capacity',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return data
}

export const useUploadProductionCapacity = (
  onUploadSuccess: () => void,
  onUploadFailure: () => void
) => {
  return useMutation(uploadProductionCapacity, {
    onSuccess: () => {
      onUploadSuccess()
    },
    onError: () => {
      onUploadFailure()
    },
  })
}

/*** End  upload */
